import React, { useEffect } from 'react';

/**
 * Meta Pixel base code. Se inyecta una sola vez, inicializa cada pixel
 * de la lista y dispara PageView (llega a todos los pixels inicializados).
 */
const PIXEL_IDS = ['2004445210124846', '2618516691925657'];
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (PIXEL_IDS.length === 0) return;
    const w = window as unknown as {
      __metaPixelInjected?: boolean;
      fbq?: unknown;
    };
    if (w.__metaPixelInjected) return;
    if (w.fbq) return;
    w.__metaPixelInjected = true;
    const inits = PIXEL_IDS.map(id => `fbq('init', '${id}');`).join('\n');
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
${inits}
fbq('track', 'PageView');`;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    PIXEL_IDS.forEach(id => {
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${id}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
    });
    document.body.appendChild(noscript);
  }, []);
  return null;
}